var _PaymentMethodMap, _ChannelIdMap;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// 支付SDK绑卡表单的DOM容器ID
export var PaymentContainerId = 'payment-form-container-id';
// 错误码多语言key的前缀，eg:settlement.creditCard.error.1004
export var ErrorPrefixKey = 'settlement.creditCard.error';
// 微信支付H5页域名映射
export var WechatPayHostMap = {
  dev: 'https://settlement-test.myshopline.cn/pay',
  test: 'https://settlement-test.myshopline.cn/pay',
  prev: 'https://settlement-preview.myshopline.cn/pay',
  prod: 'https://settlement.myshopline.cn/pay'
};

// 各个环境可能的取值
export var DevelopmentKeys = ['dev', 'develop', 'development'];
export var StgKeys = ['test', 'stg', 'staging'];
export var PrevKeys = ['preview', 'prev', 'pre'];
export var ProductionKeys = ['prd', 'prod', 'product', 'production'];
export var UrlType;

// 套餐类型。付费：paid，下期：preorder
(function (UrlType) {
  UrlType["BILL"] = "bill";
  UrlType["SUB"] = "sub";
})(UrlType || (UrlType = {}));
export var ESubType;

// 账单业务类型
(function (ESubType) {
  ESubType["paid"] = "paid";
  ESubType["preorder"] = "preorder";
})(ESubType || (ESubType = {}));
export var EBillType; // 订阅中台-服务类
(function (EBillType) {
  EBillType[EBillType["subscription"] = 1] = "subscription";
  EBillType[EBillType["commission"] = 2] = "commission";
  EBillType[EBillType["theme"] = 3] = "theme";
  EBillType[EBillType["sms"] = 4] = "sms";
  EBillType[EBillType["mid_subscription"] = 5] = "mid_subscription";
  EBillType[EBillType["mid_service"] = 6] = "mid_service";
})(EBillType || (EBillType = {}));
export var EOrderStatus;

// 账单状态
(function (EOrderStatus) {
  EOrderStatus["pending"] = "pending";
  EOrderStatus["completed"] = "completed";
  EOrderStatus["removed"] = "removed";
})(EOrderStatus || (EOrderStatus = {}));
export var EBillStatus; // NOTE: SDK内部对pending状态账单的枚举值定义，不是后端的定义

// FIXME: 为 EPaymentMethod 增加枚举有一个限制，那就是 key value 要不就是完全一样，如果需要不一样， 那就只能是大小写的区别
/** 业务方传入的支付方式 */
(function (EBillStatus) {
  EBillStatus[EBillStatus["UNPAID"] = 100] = "UNPAID";
  EBillStatus[EBillStatus["PAYED"] = 200] = "PAYED";
  EBillStatus[EBillStatus["CANCELED"] = 300] = "CANCELED";
  EBillStatus[EBillStatus["PENDING"] = 1000] = "PENDING";
  EBillStatus[EBillStatus["EXPIRED"] = 1001] = "EXPIRED";
})(EBillStatus || (EBillStatus = {}));
export var EPayMethodType;

// 支付方式选项枚举
(function (EPayMethodType) {
  EPayMethodType["Wechat"] = "Wechat";
  EPayMethodType["Creditcard"] = "CreditCard";
  EPayMethodType["HuifuChannelCasher"] = "HuifuChannelCasher";
  EPayMethodType["HuifuAlipay"] = "HuifuAlipay";
  EPayMethodType["HuifuWechat"] = "HuifuWechat";
  EPayMethodType["Airwallex"] = "Airwallex";
  EPayMethodType["FPX"] = "FPX";
  EPayMethodType["XENDIT"] = "Virtual Account";
  EPayMethodType["OneShip"] = "OneShip";
  EPayMethodType["PayNow"] = "PayNow";
  EPayMethodType["UnionPayCard"] = "UnionPayCard";
  EPayMethodType["PayPal"] = "Paypal";
})(EPayMethodType || (EPayMethodType = {}));
export var RadioPayMethod = {
  /** 银行卡选项 */
  BankCard: 'BankCard',
  /** 绑定国际卡并支付选项 */
  BindInternationalCard: EPayMethodType.Creditcard,
  /** 绑定银联卡并支付选项 */
  BindUnionCard: EPayMethodType.UnionPayCard,
  /** 原微信 */
  Wechat: EPayMethodType.Wechat,
  /** 汇付-银联聚合 */
  HuifuChannelCasher: EPayMethodType.HuifuChannelCasher,
  /** 汇付-支付宝 */
  HuifuAlipay: EPayMethodType.HuifuAlipay,
  /** 汇付-微信 */
  HuifuWechat: EPayMethodType.HuifuWechat,
  /** Airwallex */
  Airwallex: EPayMethodType.Airwallex,
  /* FPX */
  FPX: EPayMethodType.FPX,
  /* Xendit */
  XENDIT: EPayMethodType.XENDIT,
  /* Wallet */
  OneShip: EPayMethodType.OneShip,
  /** PayNow */
  PayNow: EPayMethodType.PayNow,
  /** PayPal */
  PayPal: EPayMethodType.PayPal
};

/** 业务方 => 交易SDK 支付方式的参数转换 */
export var PaymentMethodMap = (_PaymentMethodMap = {}, _defineProperty(_PaymentMethodMap, EPayMethodType.Wechat, 'Wechat'), _defineProperty(_PaymentMethodMap, EPayMethodType.Creditcard, 'CreditCard'), _defineProperty(_PaymentMethodMap, EPayMethodType.HuifuChannelCasher, 'ChannelCasher'), _defineProperty(_PaymentMethodMap, EPayMethodType.HuifuAlipay, 'Alipay'), _defineProperty(_PaymentMethodMap, EPayMethodType.HuifuWechat, 'Wechat'), _defineProperty(_PaymentMethodMap, EPayMethodType.Airwallex, 'CreditCard'), _defineProperty(_PaymentMethodMap, EPayMethodType.FPX, 'FPX'), _defineProperty(_PaymentMethodMap, EPayMethodType.UnionPayCard, 'UnionPayCard'), _PaymentMethodMap);

/** 微信支付查询状态枚举 */
export var WxPayStatus;

/** 业务方传入的支付渠道 */
(function (WxPayStatus) {
  WxPayStatus[WxPayStatus["INIT"] = 0] = "INIT";
  WxPayStatus[WxPayStatus["PAYING"] = 100] = "PAYING";
  WxPayStatus[WxPayStatus["APPROVED"] = 150] = "APPROVED";
  WxPayStatus[WxPayStatus["SUCCESS"] = 200] = "SUCCESS";
  WxPayStatus[WxPayStatus["CANCEL"] = 300] = "CANCEL";
  WxPayStatus[WxPayStatus["FAIL"] = 400] = "FAIL";
  WxPayStatus[WxPayStatus["CLOSED"] = 500] = "CLOSED";
  WxPayStatus[WxPayStatus["EXPIRED"] = 600] = "EXPIRED";
  WxPayStatus[WxPayStatus["REFUND_SUCCESS"] = 700] = "REFUND_SUCCESS";
  WxPayStatus[WxPayStatus["REFUND_FAIL"] = 800] = "REFUND_FAIL";
})(WxPayStatus || (WxPayStatus = {}));
export var EChannelId;

/** 业务方 => 交易SDK 支付渠道的参数转换 */
(function (EChannelId) {
  EChannelId["wechat"] = "wechat";
  EChannelId["stripe"] = "stripe";
  EChannelId["Huifu"] = "Huifu";
  EChannelId["Airwallex"] = "Airwallex";
  EChannelId["fpx"] = "fpx";
  EChannelId["Xendit"] = "Xendit";
  EChannelId["Custom"] = "Custom";
  EChannelId["PayNow"] = "PayNow";
  EChannelId["UMS"] = "UMS";
  EChannelId["PayPal"] = "PayPal";
})(EChannelId || (EChannelId = {}));
export var ChannelIdMap = (_ChannelIdMap = {}, _defineProperty(_ChannelIdMap, EChannelId.wechat, 'Wechat'), _defineProperty(_ChannelIdMap, EChannelId.stripe, 'Stripe'), _defineProperty(_ChannelIdMap, EChannelId.Huifu, 'Huifu'), _defineProperty(_ChannelIdMap, EChannelId.Airwallex, 'Airwallex'), _defineProperty(_ChannelIdMap, EChannelId.fpx, 'Stripe'), _defineProperty(_ChannelIdMap, EChannelId.Xendit, 'SLPayments'), _defineProperty(_ChannelIdMap, EChannelId.PayNow, 'SLPayments'), _defineProperty(_ChannelIdMap, EChannelId.UMS, 'UMSdirect'), _defineProperty(_ChannelIdMap, EChannelId.PayPal, 'SLPayments'), _ChannelIdMap);
export var ECardType;

// 绑卡渠道
(function (ECardType) {
  ECardType["Credit"] = "Credit";
  ECardType["Debit"] = "Debit";
})(ECardType || (ECardType = {}));
export var ECardChannel;
(function (ECardChannel) {
  ECardChannel["checkout"] = "checkout";
  ECardChannel["stripe"] = "stripe";
  ECardChannel["UMS"] = "UMS";
})(ECardChannel || (ECardChannel = {}));
export var EServiceType;

/**
 * 绑卡状态枚举
 */
(function (EServiceType) {
  EServiceType[EServiceType["SUB"] = 1] = "SUB";
  EServiceType[EServiceType["SERVICE"] = 2] = "SERVICE";
  EServiceType[EServiceType["INCREMENT"] = 3] = "INCREMENT";
})(EServiceType || (EServiceType = {}));
export var EBindStatus;

// 支付前的操作流转状态枚举
(function (EBindStatus) {
  EBindStatus[EBindStatus["INIT"] = 0] = "INIT";
  EBindStatus[EBindStatus["PROCESSING"] = 100] = "PROCESSING";
  EBindStatus[EBindStatus["SUCCEEDED"] = 200] = "SUCCEEDED";
  EBindStatus[EBindStatus["FAILED"] = 300] = "FAILED";
  EBindStatus[EBindStatus["EXPIRED"] = 400] = "EXPIRED";
  EBindStatus[EBindStatus["UN_BIND"] = 500] = "UN_BIND";
  EBindStatus[EBindStatus["UN_KNOW"] = 600] = "UN_KNOW";
})(EBindStatus || (EBindStatus = {}));
export var EBeforePayStatus;

// 支付前的校验节点枚举
(function (EBeforePayStatus) {
  EBeforePayStatus["break"] = "break";
  EBeforePayStatus["continue"] = "continue";
})(EBeforePayStatus || (EBeforePayStatus = {}));
export var EValidationNode;

// 下单操作的标识
(function (EValidationNode) {
  EValidationNode["beforeCreateSub"] = "beforeCreateSub";
  EValidationNode["payWithCreditCard"] = "payWithCreditCard";
})(EValidationNode || (EValidationNode = {}));
export var ECreateSubStatus;

// 发起支付时，接口返回的支付状态
(function (ECreateSubStatus) {
  ECreateSubStatus["SUCCESS"] = "SUCCESS";
  ECreateSubStatus["FAIL"] = "FAIL";
  ECreateSubStatus["BREAK"] = "BREAK";
})(ECreateSubStatus || (ECreateSubStatus = {}));
export var EBPayStatus;
(function (EBPayStatus) {
  EBPayStatus[EBPayStatus["INIT"] = 0] = "INIT";
  EBPayStatus[EBPayStatus["PROCESSING"] = 100] = "PROCESSING";
  EBPayStatus[EBPayStatus["SUCCEEDED"] = 200] = "SUCCEEDED";
  EBPayStatus[EBPayStatus["FAILED"] = 500] = "FAILED";
})(EBPayStatus || (EBPayStatus = {}));
export var RedirectAction;
(function (RedirectAction) {
  RedirectAction["Open"] = "OPEN";
  RedirectAction["Redirect"] = "REDIRECT";
})(RedirectAction || (RedirectAction = {}));
export var ActionType;
(function (ActionType) {
  ActionType["Retry"] = "RETRY";
  ActionType["Finish"] = "FINISH";
})(ActionType || (ActionType = {}));
export var EBillDetailExtOrderType;

// 待支付账单 - 取消的回调函数的参数：action的取值类型
(function (EBillDetailExtOrderType) {
  EBillDetailExtOrderType["autoRecurring"] = "autoRecurring";
})(EBillDetailExtOrderType || (EBillDetailExtOrderType = {}));
export var EOnBeforePayCancelCallbackAction;

// 汇付-固定商品代码
(function (EOnBeforePayCancelCallbackAction) {
  EOnBeforePayCancelCallbackAction["ok"] = "ok";
  EOnBeforePayCancelCallbackAction["cancel"] = "cancel";
})(EOnBeforePayCancelCallbackAction || (EOnBeforePayCancelCallbackAction = {}));
export var ProductId = '227020';
// 默认传入交易SDK的币种
export var DefaultSDKCurrency = 'USD';
// /pay/getPayMerchantId 接口的 version 参数
export var DefaultPayMerchantGetterVersion = '2.0';
// checkout渠道的绑卡失效时间
export var InvalidCKOStartTime = '2022-07-28';

// 支付中台错误码映射表
export var PayErrorMap = {
  '1004': '您的付款暂时无法处理，请重试或切换其他付款方式。',
  '1025': '由于订单金额超过您的银行卡限额，无法完成支付，请更换银行卡或选择其他支付方式；',
  '3000': '您的付款暂时无法处理，请换其他银行卡或切换其他付款方式重试。',
  '3001': '您的付款暂时无法处理，请换其他银行卡或切换其他付款方式重试。',
  '3002': '您的付款暂时无法处理，请换其他银行卡或切换其他付款方式重试。',
  '3003': '您的付款暂时无法处理，请换其他银行卡或切换其他付款方式重试。',
  '3004': '您的付款暂时无法处理，请换其他银行卡或切换其他付款方式重试。',
  '4101': '由于订单金额超过限制，您的付款无法处理。请换其他银行卡或切换其他付款方式重试。',
  '4102': '您的付款暂时无法处理，请重试或切换其他付款方式。如多次失败，请联系shopline客服或与您对接的工作人员；',
  '4103': '您的付款暂时无法处理，请重试或切换其他付款方式。如多次失败，请联系shopline客服或与您对接的工作人员；',
  '4104': '您的付款暂时无法处理，请重试或切换其他付款方式。如多次失败，请联系shopline客服或与您对接的工作人员；',
  '4105': '由于您的银行账户状态异常，导致无法完成支付。请更换银行卡或选择其他支付方式；',
  '4350': '由于您的银行账户状态异常，导致无法完成支付。请更换银行卡或选择其他支付方式；',
  '4400': '您的付款暂时无法处理，请重试或切换其他付款方式。如多次失败，请联系shopline客服或与您对接的工作人员；',
  '4401': '您的付款暂时无法处理，请重试或切换其他付款方式。如多次失败，请联系shopline客服或与您对接的工作人员；',
  '4450': '由于系统超时，3Ds身份验证未完成，请重试。如系统超时问题未改善，请联系发卡行或切换其他付款方式',
  '4451': '您的付款暂时无法处理，请换其他银行卡或切换其他付款方式重试。',
  '4452': '3Ds身份验证未通过，请重试或切换其他付款方式。',
  '4453': '银行卡上的安全码输入错误，请您核对信息后重试或切换其他付款方式。',
  '4454': '由于银行账户的余额不足，您的付款无法处理。请您更换银行卡或切换其他付款方式重试。',
  '4455': '由于卡号有误，您的付款无法处理。请核对信息后重试或切换其他付款方式。',
  '4456': '您的付款暂时无法处理，请重试或切换其他付款方式。',
  '4457': '您的付款暂时无法处理，请换其他银行卡或切换其他付款方式重试。',
  '4458': '交易正在处理中，请您稍后。',
  '4459': '因交易卡已过期，无法成功扣款。请换其他银行卡或切换付款方式重试。',
  '4460': '由于密码输入次数超过限制，您的付款无法处理。请切换其他银行卡或选择其他付款方式。',
  '4461': '由于订单金额超过您的银行卡限额，无法完成支付，请更换银行卡或选择其他支付方式。',
  '4462': '由于密码错误，您的付款无法处理。请重试或使用其他付款方式。',
  '4463': '您的付款暂时无法处理，请换其他银行卡或切换其他付款方式重试。',
  '4550': '您的付款已取消。如需继续，请重试。',
  '4551': '/',
  '4600': '出现未知错误，导致您的付款暂无法处理。请重试或切换其他付款方式。如多次失败，请联系shopline客服或与您对接的工作人员；'
};

// ums 支付渠道对应的错误码映射表
export var UMSPayErrorMap = {
  '1': '交易失败。详情请咨询95516',
  '2': '系统未开放或暂时关闭，请稍后再试。',
  '6': '系统繁忙，请稍后再试',
  '10': '报文格式错误',
  '11': '验证签名失败',
  '12': '重复交易，请发起查询交易',
  '13': '报文交易要素缺失',
  '14': '批量文件格式错误',
  '15': '报文交易要素不支持',
  '30': '交易未通过，请尝试使用其他银联卡支付或联系95516。',
  '31': '商户状态不正确',
  '32': '无此交易权限',
  '33': '交易金额超限',
  '34': '查无此交易，请稍后发起交易状态查询，若10分钟后查询依旧返回34应答码，则表示原交易失败。',
  '35': '原交易不存在或状态不正确',
  '36': '与原交易信息不符',
  '37': '已超过最大查询次数或操作过于频繁',
  '38': '银联风险受限',
  '39': '交易不在受理时间范围内',
  '40': '绑定关系检查失败',
  '41': '批量状态不正确，无法下载',
  '42': '扣款成功但交易超过规定支付时间',
  '43': '无此业务权限，详情请咨询95516',
  '44': '输入号码错误或暂未开通此项业务，详情请咨询95516',
  '45': '原交易已被成功退货或已被成功撤销',
  '46': '交易已被成功冲正',
  '47': '发卡机构Ⅱ、Ⅲ类户日累计或年累计交易限额超限',
  '48': '发卡机构Ⅲ类户账户余额超限',
  '49': '获取云闪付绑定的银行卡失败',
  '60': '交易失败，详情请咨询您的发卡行',
  '61': '输入的卡号无效，请确认后输入',
  '62': '交易失败，发卡银行不支持该商户，请更换其他银行卡',
  '63': '卡状态不正确',
  '64': '卡上的余额不足',
  '65': '输入的密码、有效期或CVN2有误，交易失败。',
  '66': '持卡人身份信息或手机号输入不正确，验证失败',
  '67': '密码输入次数超限',
  '68': '您的银行卡暂不支持该业务，请向您的银行或95516咨询',
  '70': '交易已跳转，等待持卡人输入',
  '71': '动态口令或短信验证码校验失败',
  '72': '您尚未在{}银行网点柜面或个人网银签约加办银联无卡支付业务，请去柜面或网银开通或拨打{}',
  '73': '支付卡已超过有效期',
  '74': '扣款成功，销账未知',
  '75': '扣款成功，销账失败',
  '76': '需要验密开通',
  '77': '银行卡未开通认证支付',
  '78': '发卡行交易权限受限，详情请咨询您的发卡行',
  '79': '此卡可用，但发卡行暂不支持短信验证',
  '80': '交易失败，Token 已过期',
  '81': '月累计交易笔数(金额)超限',
  '82': '需要校验密码',
  '83': '发卡行（渠道）处理中',
  '87': '支付次数超限',
  '89': '无此Token、TR状态无效或者Token状态无效',
  '90': '交易已制单，请至银行页面复核',
  '91': '关闭订单失败，订单交易正在处理',
  '92': '关闭订单失败，订单交易已成功'
};

// 升级类型
export var UpgradeTypeEnum;

// API调用之后返回的code枚举
(function (UpgradeTypeEnum) {
  UpgradeTypeEnum["DEFAULT"] = "DEFAULT";
  UpgradeTypeEnum["REPLACE"] = "REPLACE";
})(UpgradeTypeEnum || (UpgradeTypeEnum = {}));
export var APIResponseCode;
(function (APIResponseCode) {
  APIResponseCode["SUCCESS"] = "SUCCESS";
})(APIResponseCode || (APIResponseCode = {}));
export var langMap = {
  'zh-hans-cn': 'zh-CN',
  'zh-hant-tw': 'zh-TW'
};
export var CreditCardImg;
(function (CreditCardImg) {
  CreditCardImg["Visa"] = "visa";
  CreditCardImg["Master"] = "master";
  CreditCardImg["JCB"] = "jcb";
  CreditCardImg["Amex"] = "amex";
  CreditCardImg["UnionPay"] = "unionPay";
})(CreditCardImg || (CreditCardImg = {}));